module.exports = __webpack_public_path__ + "static/media/Plumbing Manufacturers International Logo.53a1341e.png";